export default "__VITE_ASSET__Jio$w$Ih__"